import React from 'react';
import { ImportPatientPreviewTemplate } from 'themes/application/import/pages';
import { observer } from 'mobx-react';
import { ImportPatientPreviewViewStore } from 'application/import/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportPatientPreviewViewStore(rootStore), 'previewViewStore')
@observer
class ImportPatientPreview extends React.Component {
    render() {
        return <ImportPatientPreviewTemplate {...this.props} />
    }
}

export default ImportPatientPreview;